import React, { Component } from 'react';
import { connect } from 'react-redux';
class TriggerOrderMsgDialog extends Component {
    state = {  }
    render() {
        const {language} = this.props;
        return (
            <div style={{width:'500px',height:'150px',padding:'20px',lineHeight:'25px'}}>
                {language.common_trigger_Order_msg}
            </div>
        );
    }
}
 
export default connect(
    state => ({
        language: state.app.language,
    })
)(TriggerOrderMsgDialog)